import create from 'zustand';

type Triggers = {
  appleFall: boolean
}

type TriggerStore = Triggers & {
  set: (key: keyof Triggers, value: boolean) => void
}

const useTriggerStore = create<TriggerStore>(set => ({
  appleFall: false,

  set: (key, value) => set(state => {
    const clone = { ...state };
    clone[key] = value;
    return clone;
  })
}));

export default useTriggerStore;